import React, { useState, useEffect } from 'react';
import MainLayout from '../../../commons/layout/MainLayout';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ROUTERS from '../../../commons/constans/router';
import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import Slider from '../../../commons/components/Slider';
import ModalComponent from '../../../commons/components/Modal/ModalComponent';
import Step1Component from '../components/steps/step1';
import Step2Component from '../components/steps/step2';
import Step3Component from '../components/steps/step3';
import Step4Component from '../components/steps/step4';
import InAppPaymentComponent from './steps/inAppPayment';
import {PRICE_PAY, STEPS} from '../../../commons/constans/stepVideo';
import { useDispatch, useSelector } from 'react-redux';
import DialogComponent from '../../../commons/components/Modal/DialogComponent';
import RenderBannerComponent from '../../../commons/components/Banner';
import { useUser } from '../../../commons/customHooks/Account';
import { updateSuccess } from '../../Account/redux/actions';
import { isAndroid, isIOS } from 'react-device-detect';
import { PRODUCT_ID_ANDROID, PRODUCT_ID_IOS } from '../../../commons/constans/payment';
import Loading from '../../../commons/components/Loading';
import API, { ROUTES } from '../../../commons/api/api';
import axios from 'axios';
import { log } from '../../../utils/helpers';

type Props = {
  pushDataVideoStepOne: Function,
  pushDataVideoStepTwo: Function,
  pushDataVideoStepThree: Function,
  pushDataVideoStepFour: Function,
  videoPaymentSaveRequest: Function,
  videoPaymentClearState: Function,
  banners: Object,
  character: Object,
  coupon: Array,
  videoTemplate: Object,
  characterDetail: Array,
  point: Number,
  restrictedKeyword: Array
};

const VideoMessageMakerStepComponent = ({
  pushDataVideoStepOne,
  pushDataVideoStepTwo,
  pushDataVideoStepThree,
  pushDataVideoStepFour,
  videoPaymentSaveRequest,
  videoPaymentClearState,
  banners,
  character,
  characterDetail,
  coupon,
  videoTemplate,
  point,
  restrictedKeyword,
}: Props) => {
  const { steps, resultCreateData } = useSelector(
    (state) => state.videoReducers
  );

  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const stepArr = [STEPS.ONE, STEPS.TWO, STEPS.THREE, STEPS.FOUR];
  const [step, setStep] = useState(STEPS.ONE);
  const [dataSteps, setDataSteps] = useState({});
  const [dataResPayment, setDataResPayment] = useState({
    isShow: false,
    msg: '',
    status: null
  });

  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const [ loadingSubmit, setLoadingSubmit ] = useState(false)
  const [statusInApp, setStatusInApp] = useState(false)
  const [loadingInApp, setLoadingInApp] = useState(false);

  const {user} = useUser();

  useEffect(() => {
    scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (state && state.screen_back === 'coupon_box') {
      setStep(params.step);
      navigate(ROUTERS.VIDEO_MESSAGE_MAKER_STEP_PATH(params.step));
    } else {
      setStep(step);
      navigate(ROUTERS.VIDEO_MESSAGE_MAKER_STEP_PATH(step));
    }
  }, [step]);

  useEffect(() => {
    if (resultCreateData) {
      setLoadingSubmit(false)
      switch (resultCreateData.status) {
        case 200:
          // setDataResPayment({
          //   isShow: true,
          //   msg: '영상 제작 중입니다',
          //   status: 200
          // });
          console.log(105, resultCreateData);
          let dataMerge = {
            name: steps.step_2?.child_name || '',
            template: steps.step_2?.code || 1,
            character: steps.step_1?.character_pose_name === '차탄' ? 'chatan' : 'chuchu',
            video_id: resultCreateData.data?.data?.id || null,
            user_id: user?.id || null
          }
          console.log(114, dataMerge);
          navigate(ROUTERS.VIDEO_COMPLETED, {state: {
            dataMerge 
          }});
          // dispatch(videoPaymentClearState());
          break;
        case 422:
          setDataResPayment({
            isShow: true,
            msg: '영상편지 결제',
            status: 422
          });
          break;
        default:
          setDataResPayment({
            isShow: false,
            msg: '',
            status: null
          });
          break;
      }
    }
  }, [resultCreateData]);

  const handelCloseModalComplete = () => {
    console.log('handelCloseModalComplete');
    // setDataResPayment({
    //   isShow: false,
    //   msg: '사용자에 의해 인앱결제가 취소되었습니다',
    //   status: 'cancel'
    // });a
    setDataResPayment({
      ...dataResPayment,
      isShow: false,
    });
    setIsShowTooltip(true);
  };

  const handleLeftClick = () => {
    if (stepArr.indexOf(params.step - 1) != -1) {
      setStep(params.step - 1);
    } else {
      navigate(ROUTERS.VIDEO_MESSAGE_MAKER);
    }
  };

  const pushRoute = (path) => {
    navigate(path, {state: steps.step_4});
  };

  const handelDataVideoStep = (data, step) => {
    switch (step) {
      case STEPS.ONE:
        setDataSteps({
          ...dataSteps,
          ...data.step_1,
        });
        dispatch(pushDataVideoStepOne(data.step_1));
        break;
      case STEPS.TWO:
        setDataSteps({
          ...dataSteps,
          ...data.step_2,
        });
        dispatch(pushDataVideoStepTwo(data.step_2));
        break;
      case STEPS.THREE:
        setDataSteps({
          ...dataSteps,
          ...data.step_3,
        });
        dispatch(pushDataVideoStepThree(data.step_3));
        break;
      case STEPS.FOUR:
        setDataSteps({
          ...dataSteps,
          ...data.step_4,
        });
        dispatch(pushDataVideoStepFour(data.step_4));
        break;
      default:
        break;
    }
  };



  const submitPayment = (data) => {
    //debug 

    // let dataPaymentInApp = {
    //   child_name: steps.step_2?.child_name || '',
    //   title: steps.step_2?.title || '',
    //   content: steps.step_2?.content || '',
    //   content_template_id: steps.step_2?.content_template_id == 9999 ? null :  steps.step_2?.content_template_id,
    //   character_pose_id: steps.step_1?.character_pose_id || '',
      
    //   payment_type: steps.step_4?.payment_type || '',
    //   use_point: 0,
    //   use_coupon: steps.step_4?.coupon_id || null,
    //   use_coupon_message: steps.step_4?.coupon_message_id || null,
    //   used_money_id: null,
    //   payment_at: '2022-09-13 15:11:04',
    //   amount: 8000,
    //   transaction_code: ''
    // };
    // dispatch(videoPaymentSaveRequest(dataPaymentInApp));
    // return;

    //code
    console.log(220, data);
    if (data && data === 'payment') {
      //case choosed coupon
      if (steps.step_4.coupon_id && steps.step_4.coupon_id !== null) {
        console.log(1111);
        payment('payment');
      } else {
        console.log(2222);

        //payment in app
        setDataResPayment({
          isShow: true,
          msg: '영상편지 결제',
          status: 422
        });
      }
    }
  };

  const goToSteps = (step) => {
    setStep(step);
  };

  const goToPageSuccess = () => {
    
    dispatch(videoPaymentClearState());
    navigate(ROUTERS.VIDEO_COMPLETED);
  }

  const removeCouponStep4 = () => {
    dispatch(
      pushDataVideoStepFour({
        coupon_name: '',
        coupon_img: '',
        coupon_id: null,
      })
    );
  };

  const renderStep = (step) => {
    switch (parseInt(step)) {
      case STEPS.ONE:
        return (
          <Step1Component
            steps={steps}
            pushDataVideoStepTwo={handelDataVideoStep}
            pushDataVideoStepOne={handelDataVideoStep}
            goToSteps={goToSteps}
            character={character}
            characterDetail={characterDetail}
          />
        );
      case STEPS.TWO:
        return (
          <Step2Component
            steps={steps}
            pushDataVideoStepTwo={handelDataVideoStep}
            goToSteps={goToSteps}
            videoTemplate={videoTemplate}
            restrictedKeyword={restrictedKeyword}
          />
        );
      case STEPS.THREE:
        return (
          <Step3Component
            steps={steps}
            pushDataVideoStepThree={handelDataVideoStep}
            pushDataVideoStepTwo={handelDataVideoStep}
            goToSteps={goToSteps}
          />
        );
      case STEPS.FOUR:
        return (
          <Step4Component
            steps={steps}
            submitPayment={submitPayment}
            pushRoute={(path) => pushRoute(path)}
            pushDataVideoStepFour={handelDataVideoStep}
            removeCoupon={removeCouponStep4}
            coupon={coupon}
            point={point}
            loadingSubmit={loadingSubmit}
            isShowTooltip={isShowTooltip}
          />
        );
      default:
        return (
          <Step1Component
            steps={steps}
            pushDataVideoStepOne={handelDataVideoStep}
            goToSteps={goToSteps}
          />
        );
    }
  };

  const payment = (type) => {
    let dataPayment = {
      child_name: steps.step_2?.child_name || '',
      title: steps.step_2?.title || '',
      content: steps.step_2?.content || '',
      content_template_id: steps.step_2?.content_template_id == 9999 ? null :  steps.step_2?.content_template_id,
      character_pose_id: steps.step_1?.character_pose_id || '',
      payment_type: steps.step_4?.payment_type || '',
      use_point:  0,
      use_coupon: steps.step_4?.coupon_id || null,
      use_coupon_message: steps.step_4?.coupon_message_id || null,
      payment_at: steps.step_4?.payment_at || '',
      payment_id: null,
    };
    console.log('deviceKey : ', window.appDevice.deviceKey);
    setLoadingSubmit(true)
    if (type === 'paymentInApp') {
      console.log(dataPayment, 'paymentInApp');
      let productId;
      let gateway;
      //check product id
      if (isAndroid) {
        if (dataPayment.payment_type === '1pay') {
          productId = PRODUCT_ID_ANDROID[8000]
        } else {
          productId = PRODUCT_ID_ANDROID[15000]
        }
        gateway= 'CHPLAY';
      }
      if (isIOS) {
        if (dataPayment.payment_type === '1pay') {
          productId = PRODUCT_ID_IOS[8000];
        } else {
          productId = PRODUCT_ID_IOS[15000]
        }
        gateway= 'APPLESTORE';
      }
      
      let dataPaymentRqs = {
        itemID: productId,
        gateway 
      }
      console.log(dataPaymentRqs, 'dataPaymentRqs');
      // B1: Webview tạo request payment. Thành công sẽ gửi lên cho app transactionCode và ItemID
      API.post(ROUTES.API_PAYMENT_REQUEST, dataPaymentRqs).then(res => {
        console.log('ROUTES.API_PAYMENT_REQUEST', res);
        if (res.status == 200) {
          let dataResponse = res.data.data;
          let dataSignal = {
            transactionCode: dataResponse.paymentCode,
            itemID : dataPaymentRqs.itemID,
            deviceKey : 'xxxxxxxx'
          }
          window.nativePaymentInApp(dataSignal);
        }
      }).catch(e => {
        console.log(e, 'eeeeeeeeeeeeeeeeee');
        setLoadingSubmit(false);
      })
      //show popup payment inapp success
      // setStatusInApp(true);
      // setDataResPayment({
      //   isShow: false,
      //   msg: '',
      //   status: null
      // })
    }else{
      dispatch(videoPaymentSaveRequest(dataPayment));
    }
  };


  const paymentInApp = () => {
    console.log(392, 'paymentInApp');
    payment('paymentInApp');
  };

  window.callPaymentSuccess = function (data) {
    // B2: Native thanh toán với store, xong process Payment. Thành công thì trả xuống cho webview transactionCode và itemID
    // B3: Webview verify payment một lần nữa rồi tiến hành chế tác video. 
    // Khi submit chế tác, kiểm tra ở phía server, nếu request chế tác là thanh toán in app thì tiến hành tính tiền, 
    // quy đổi tiền thừa thành point. Nhớ xin text nội dung point transaction.
    let dataPayment = JSON.parse(data);
    // alert('callPaymentSuccess');
    // console.log('dataPayment', dataPayment);
    if (dataPayment.transactionCode && dataPayment.itemID) {
      API.post(ROUTES.API_PURCHASE_VERIFY, dataPayment).then(res => {
        console.log('ROUTES.API_PURCHASE_VERIFY', res);
        if (res.status == 200) {
          let dataRes = res.data.data;
          let dataPaymentInApp = {
            child_name: steps.step_2?.child_name || '',
            title: steps.step_2?.title || '',
            content: steps.step_2?.content || '',
            content_template_id: steps.step_2?.content_template_id == 9999 ? null :  steps.step_2?.content_template_id,
            character_pose_id: steps.step_1?.character_pose_id || '',
            
            payment_type: steps.step_4?.payment_type || '',
            use_point: 0,
            use_coupon: steps.step_4?.coupon_id || null,
            use_coupon_message: steps.step_4?.coupon_message_id || null,
            used_money_id: dataRes?.id || null,
            payment_at: dataRes?.payment_date || null,
            amount: +dataRes?.amount || null,
            transaction_code: dataRes?.paymentCode || ''
          };

          dispatch(videoPaymentSaveRequest(dataPaymentInApp));
        }
      }).catch(e => {
        console.log(e, 'eeeeeeeeeeeeeeeeee');
      })
    }
    setLoadingSubmit(false);
  }

  window.callPaymentFail = function () {
    setLoadingSubmit(false);
  }

  const handleClose = () => {
    console.log('dataResPayment', dataResPayment);
    if (dataResPayment.status === 200 || dataResPayment.status === 'cancel') {
      // dispatch(videoPaymentClearState());
      // navigate(ROUTERS.HOME);
      setDataResPayment({
        isShow: false,
        msg: '',
        status: null
      });
    }
  };

  return (
    <MainLayout
      pageID={'video-message-marker'}
      activeNav={'VIDEO'}
      displayBottomNav={false}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="영상 편지"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="step">
        <div className="step-video__top">
          <div className="stepper-wrapper">
            <div className={`stepper-item ${step >= 1 && 'active'}`}>
              <div className="step-counter">
                <img src="/images/icon_video_step01.svg" alt="step1" />
              </div>
              <div className="step-name">캐릭터 선택</div>
            </div>
            <div className={`stepper-item ${step >= 2 && 'active'}`}>
              <div className="step-counter">
                <img src="/images/icon_video_active_step02.svg" alt="step2" />
                <img
                  src="/images/icon_video_step02.svg"
                  alt="step2"
                  className="unactive"
                />
              </div>
              <div className="step-name">정보 선택</div>
            </div>
            <div className={`stepper-item ${step >= 3 && 'active'}`}>
              <div className="step-counter">
                <img src="/images/icon_video_active_step03.svg" alt="step3" />
                <img
                  src="/images/icon_video_step03.svg"
                  alt="step2"
                  className="unactive"
                />
              </div>
              <div className="step-name">문구확인</div>
            </div>
            <div className={`stepper-item ${step >= 4 && 'active'}`}>
              <div className="step-counter">
                <img src="/images/icon_video_active_step04.svg" alt="step4" />
                <img
                  src="/images/icon_video_step04.svg"
                  alt="step4"
                  className="unactive"
                />
              </div>
              <div className="step-name">결제</div>
            </div>
          </div>
          {/* <RenderBannerComponent banners={banners} /> */}
        </div>
        <div className="step-video-content">{renderStep(step)}</div>
        <ModalComponent
          id={'js-payment-inApp'}
          show={dataResPayment?.status == 422 && dataResPayment.isShow ? true : false}
          heading={true}
          title={dataResPayment?.msg || ''}
          closeButton={true}
          handleClose={() => handelCloseModalComplete()}
          swipeDown={false}
        >
          <InAppPaymentComponent steps={steps} paymentInApp={paymentInApp} loadingSubmit={loadingSubmit}/>
        </ModalComponent>

        <DialogComponent
          id={`js-payment`}
          show={dataResPayment?.status == 200 && dataResPayment.isShow ? true : dataResPayment?.status == 'cancel' && !dataResPayment.isShow ? true : false}
          children={dataResPayment?.msg || ''}
          title={`알림`}
          handleClose={handleClose}
          closeBtn={`확인`}
        ></DialogComponent>

        <DialogComponent
          id={`js-popup-inApp-success`}
          show={statusInApp}
          // children={'payment inapp success'}
          title={`알림`}
          handleClose={goToPageSuccess}
          closeBtn={`홈으로 이동`}
        >
          <div>
            영상이 제작 중입니다.. <br />
            제작이 완료되면 push 알림으로 <br />
            알려드립니다. <br />
          </div>
        </DialogComponent>
      </div>
    </MainLayout>
  );
};

export default VideoMessageMakerStepComponent;
